<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card v-if="dialog && table">
      <v-card-text>
        <v-container>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-left">Время</th>
                <th class="text-left">Гость</th>
                <th class="text-center">Кол-во</th>
                <th class="text-center">Коммент</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in table.today_reservation" :key="item.id">
                <td>{{ item.date_time_visit.trim().split(' ')[1] }}</td>
                <td>{{ item.guest.first_name +' '+ item.guest.last_name }} <br> {{item.guest.phone}}</td>
                <td>{{item.count_person}}</td>
                <td>{{item.notes}}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-container>
      </v-card-text>
      <div class="d-flex justify-center">
        <v-spacer></v-spacer>
        <v-col cols="12">
          <v-btn color="error"  block @click="resetTables">Закрыть</v-btn>
        </v-col>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "Transfer",
    mounted() {
      bus.$on('infoAboutTable', (payload) => {
        this.table = payload;
        this.dialog = true;
      })

      setTimeout(() => {
        window.location.reload()
      }, 90000);
    },
    data() {
      return {
        dialog: false,
        table : null
      }
    },
    methods : {
      resetTables(){
        this.dialog = false
      },
    }
  }
</script>

<style scoped>
  .border {
    border: 2px dashed orange;
  }
</style>
